/**
 * Client: modul contact — etichetă butoane + popup.
 */
import { DEFAULT_CONTACT_LABEL } from './contact-module-admin.js?v=82.86';

export function getContactLabel(settings) {
  const label = String(settings?.reservationLabel || '').trim();
  return label || DEFAULT_CONTACT_LABEL;
}

export function getContactClientMessage(settings) {
  return String(settings?.reservationMessage || '').trim();
}

/** Moduri de contact completate: telefon, WhatsApp, link (în ordinea afișării). */
export function getContactChannels(settings) {
  const s = settings || {};
  const out = [];
  const phone = String(s.reservationPhone || '').trim();
  const wa = String(s.reservationWhatsapp || '').trim();
  const link = String(s.reservationLink || '').trim();
  if (phone) out.push({ kind: 'phone', value: phone });
  if (wa) out.push({ kind: 'whatsapp', value: wa });
  if (/^https?:\/\//i.test(link)) out.push({ kind: 'link', value: link, label: String(s.reservationLinkLabel || '').trim() });
  return out;
}

export function isContactModuleAvailable(settings) {
  if (settings?.reservationEnabled !== true) return false;
  return getContactChannels(settings).length > 0;
}

export function applyContactModuleClientUI(settings) {
  const label = getContactLabel(settings);
  const show = isContactModuleAvailable(settings);

  const fab = document.getElementById('clientReservationFab');
  const fabLabel = fab?.querySelector('.client-fab-pill__label');
  if (fab) {
    fab.style.display = show ? 'inline-flex' : 'none';
    fab.setAttribute('aria-label', label);
  }
  if (fabLabel) fabLabel.textContent = label;

  const menuBtn = document.getElementById('clientMenuReservationBtn');
  if (menuBtn) {
    menuBtn.style.display = show ? 'inline-flex' : 'none';
    menuBtn.setAttribute('aria-label', label);
  }
}
